// Components==============
import React, { useContext, useEffect } from 'react';
import { TranslateType } from 'typings';
import { FormContext } from 'utilities/FormContext';
import './Form.module.scss';
// =========================

type Props = {
  name: string;
  label?: TranslateType;
  value?: string;
  dropdown: React.ReactNode;
};

export default function FormDropdown({ name, label, dropdown, value }: Props) {
  const { setFormValues, errors } = useContext(FormContext);

  useEffect(() => {
    if (setFormValues && value)
      setFormValues((prev: any) => ({ ...prev, [name]: value }));
  }, [value]);

  return (
    <div styleName="wrapper dropdown-wrapper">
      {label && <label htmlFor={name}>{label}</label>}
      {dropdown}
      {errors[name][0] ? <p styleName="error">{errors[name][0]}</p> : null}
    </div>
  );
}
